<template>
  <div class="stepper" @click="goTo">
    <span v-if="number" class="stepper__number">{{number}}</span>
    <img v-else class="stepper__icon" :src="stepCompleteIcon" />
    <span class="stepper__title">{{title}}</span>
    <div class="stepper__cart-item" v-if="isDumpsterStepper">
      <img class="stepper__cart-img" :src="dumpsterImage" />
      <span class="stepper__cart-size">{{item.size}} Yard Dumpster</span>
    </div>
    <span v-if="!isFutureStep" class="stepper__edit">edit</span>
  </div>
</template>

<script>
import config from '@/config'
const { cdn } = config
export default {
  data: () => {
    return {
      stepCompleteIcon: `${cdn}step-complete-checkmark.svg`
    }
  },
  props: {
    title: {
      required: true
    },
    number: {
      required: false
    },
    isDumpsterStepper: {
      required: false,
      default: false
    },
    isFutureStep: {
      default: true
    },
    path: {
      type: String,
      required: true,
      default: '/cart'
    }
  },
  methods: {
    goTo () {
      if (this.isDumpsterStepper) {
        this.$router.push(this.path)
      }
      if (!this.isFutureStep) {
        this.$router.push(this.path)
      }
    }
  },
  computed: {
    item () {
      return this.$store.state.cart.item
    },
    dumpsterImage () {
      return `${cdn}${this.item.size}-yard-dumpster-card.png`
    }
  }
}
</script>
